export default {
  data: () => ({
    menuContextOpened: '',
  }),
  computed: {
    refContextMenu() {
      return (key) => {
        const context = this.$refs[
          this.createContextRef(key)
        ];
        return context || {
          show: () => {},
          close: () => {},
        };
      };
    },
    showContextMenu() {
      return (ev, key) => {
        this.handleCloseOpenedContextMenu(key);
        this.refContextMenu(key).show(ev);
      };
    },
    handleCloseOpenedContextMenu() {
      return (key) => {
        const ref = this.createContextRef(key);
        const menu = this.menuContextOpened;

        if (ref !== menu) {
          this.refContextMenu(
            String(menu).replace(
              this.createContextRef(),
              '',
            ),
          )
            .close();
        }
        this.$nextTick(
          () => {
            this.menuContextOpened = ref;
          },
        );
      };
    },
  },
  methods: {
    createContextRef(key = '') {
      return `context_menu_${key}`;
    },
  },
};
